import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import BaseButton from "@/components/buttons/BaseButton.vue";
import { useI18n } from "@/composables/useI18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectFileDialog',
  props: {
  headline: {
    type: String,
    required: false,
    default: ""
  },
  contentText: {
    type: String,
    required: false,
    default: ""
  },
  buttonConfirm: {
    type: String,
    required: false,
    default: ""
  },
  buttonCancel: {
    type: String,
    required: false,
    default: ""
  }
},
  emits: ["onDialogCancel", "onDialogConfirm"],
  setup(__props, { expose, emit }) {

const props = __props;


const {
  t
} = useI18n();



const headlineLocalized = computed(() => props.headline || t("headline"));
const contentTextLocalized = computed(() => props.contentText || t("contentText"));
const buttonConfirmLocalized = computed(() => props.buttonConfirm || t("buttonConfirm"));
const buttonCancelLocalized = computed(() => props.buttonCancel || t("buttonCancel"));

const isActive = ref(false);
const file = ref<File>();

const show = () => {
  isActive.value = true;
};

const hide = () => {
  isActive.value = false;
};

const cancel = () => {
  hide();
  emit("onDialogCancel");
};

const confirm = () => {
  hide();
  emit("onDialogConfirm", file.value);
};



expose({
  show
})


return { __sfc: true,t, props, headlineLocalized, contentTextLocalized, buttonConfirmLocalized, buttonCancelLocalized, isActive, file, show, hide, cancel, confirm, emit, BaseButton }
}

})